import { Module } from 'vuex'
import Cookies from 'js-cookie'
import { GlobalDataProps, actionWrapper } from './index'
import { ListData, RespData } from './respTypes'
import { baseAPIURL } from '../main'

function getDomainWithoutSubdomain(url:string) {
  const urlParts = new URL(url).hostname.split('.')

  return urlParts
    .slice(0)
    .slice(-(urlParts.length === 4 ? 3 : 2))
    .join('.')
}
export interface UserDataProps {
  userName?: string;
  _id?: string;
  updatedAt?: string;
  createdAt?: string;
  avatar?: string;
  isValid?: boolean;
  provider?: string;
  email?: string;
  cellphone?: string;
  valiFrom?: Date;
  valiTo?: Date ;
  password?: string;
  nickName?: string;
  role?: string;
  type?: string;
  // 邀请者 ID
  inviter?: string;
  // 账户余额
  balance?: number;
  // token
  token?: number;
}

export interface PaginationProps {
  count: number;
  pageSize: number;
  currentPage: number;
}
export interface UserProps {
  isLogin: boolean;
  token?: string;
  data: UserDataProps;
  users: Required<UserDataProps>[];
  count: number;

}
const user: Module<UserProps, GlobalDataProps> = { 
  state: {
    isLogin: false,
    data: {},
    token: Cookies.get('x-cid'),
    users: [],
    count: 0,
  },
  mutations: {
    login(state, rawData: RespData<{ token: string }>) {
      const { token } = rawData.data
      state.token = token
    },
    fetchCurrentUser(state, rawData: RespData<UserDataProps>) {
      state.isLogin = true
      state.data = { ...rawData.data }
    },
    updateUser(state, rawData: RespData<Required<UserDataProps>>) {
      const { data } = rawData
      const index = state.users.findIndex(user => user._id === data._id)
      if (index > -1) {
        state.users[index] = data
      }
    },
    deleteUser(state, { payload }: RespData<any>) {
      if (payload && payload.urlParams) {
        const { urlParams } = payload
        state.users = state.users.filter(user => user._id !== urlParams.id)
      }
    },
    getUsers(state, rawData: ListData<Required<UserDataProps>[]>) {
      const { data, count, pageSize, currentPage } = rawData.data
      state.users = data
      state.count = count
    },
    createUser(state, rawData: RespData<Required<UserDataProps>>) {
      const { data } = rawData
      state.users.push(data)
    },
    logout(state) {
      state.token = ''
      state.isLogin = false
      const domain = getDomainWithoutSubdomain(baseAPIURL)
      Cookies.remove('x-cid', { path: '/', domain: `.${domain}` })
    }
  },
  actions: {
    login: actionWrapper('/api/login', 'login', { method: 'post'}),
    fetchCurrentUser: actionWrapper('/api/user/current', 'fetchCurrentUser'),
    loginAndFetch({ dispatch }, loginData) {
      console.log(loginData)
      return dispatch('login', loginData).then(() => {
        return dispatch('fetchCurrentUser')
      })
    },
    updateUser: actionWrapper('/api/users/:id', 'updateUser', { method: 'patch'}),
    deleteUser: actionWrapper('/api/users/:id', 'deleteUser', { method: 'delete'}),
    createUser: actionWrapper('/api/usersAdmin', 'createUser', { method: 'post'}),
    getUsers: actionWrapper('/api/users', 'getUsers'),
  }
}

export default user